import { createAuthenticatedAxiosInstance } from "../auth/auth.slice";

const baseUrl = import.meta.env.VITE_API_URL;

export const backupService = {
    /**
     * Download a full database backup as a `.sql` file. Returns the raw axios
     * response so the caller can read the filename from Content-Disposition and
     * hand the blob to file-saver.
     */
    download: async () => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.get(baseUrl + "backup/download", {
            responseType: "blob",
        });
        return response;
    },
};
